import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
  * @function evaluate - evaluate taggedFieldOptionsBehavior
  */

export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const tagOptions = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'tag/options'
  });
  const importFormType = content.importFormType;
  const _Object$keys = Object.keys(importFormType),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    formTypeIdentifier = _Object$keys2[0];
  const _ref = tagOptions ? tagOptions[formTypeIdentifier] : {
      children: []
    },
    children = _ref.children;
  return children;
};
export default {
  evaluate
};